package one.healthium.uscreen.ui.util

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.NativePaint
import androidx.compose.ui.graphics.Outline
import androidx.compose.ui.graphics.Paint
import androidx.compose.ui.graphics.Path
import androidx.compose.ui.graphics.drawOutline
import androidx.compose.ui.graphics.drawscope.DrawScope
import androidx.compose.ui.graphics.drawscope.drawIntoCanvas
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp

fun DrawScope.drawShadow(
    path: Path,
    color: Color = Color.Black.copy(0.25f),
    blur: Dp = 4.dp,
    offsetY: Dp = 0.dp,
    offsetX: Dp = 0.dp,
) {
    drawIntoCanvas { canvas ->
        val paint = Paint().apply {
            this.color = color
            if (blur.toPx() > 0f) {
                asFrameworkPaint().setBlurMaskFilter(blur.toPx())
            }
        }
        canvas.save()
        canvas.translate(offsetX.toPx(), offsetY.toPx())
        canvas.drawOutline(Outline.Generic(path), paint)
        canvas.restore()
    }
}

fun DrawScope.drawShadow(
    path: Path,
    paint: Paint,
    offsetY: Dp = 0.dp,
    offsetX: Dp = 0.dp,
) {
    drawIntoCanvas { canvas ->
        canvas.save()
        canvas.translate(offsetX.toPx(), offsetY.toPx())
        canvas.drawOutline(Outline.Generic(path), paint)
        canvas.restore()
    }
}

fun createShadowPaint(
    color: Color = Color.Black.copy(0.25f),
    blurRadiusPx: Float = 0f,
): Paint = Paint().apply {
    this.color = color
    if (blurRadiusPx > 0f) {
        asFrameworkPaint().setBlurMaskFilter(blurRadiusPx)
    }
}

internal expect fun NativePaint.setBlurMaskFilter(blurRadius: Float)
